import { z } from 'zod'

/** 禮遇安排紀錄 - 套裝子項目清單 Schema */
export const courtesyArrangementSuitCourtesySchema = z.object({
  /**
   * 分類
   * PDBG:超額行李
   * LOUG:貴賓室
   * PRCK:優先劃位櫃檯
   * PRBD:優先登機
   * PRBG:優先裝卸行李
   * */
  type: z.string(),
  /** 券號 */
  couponNo: z.string(),
  /** 禮遇安排日期 */
  arrangementTime: z.string(),
  /** EMD號碼 */
  emdNo: z.string()
})

/** 禮遇安排紀錄 - 套裝子項目清單 */
export interface CourtesyArrangementSuitCourtesy
  extends z.infer<typeof courtesyArrangementSuitCourtesySchema> {}
